import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { setLogo } from './logo.actions';
import { LogoInterface } from '@/app/_core/domain/interfaces/logo/logo.interface';
import { LogoConfig } from '@/app/_core/domain/models/logo/logo.model';
import { selectLogo } from './logo.selectors';

@Injectable({
  providedIn: 'root'
})
export class LogoStoreAdapter implements LogoInterface {
  private readonly _store = inject(Store);

  public setLogo(logo: LogoConfig): void {
    this._store.dispatch(setLogo({ logo }));
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////
  public readonly selectLogoSig = this._store.selectSignal(selectLogo.logo);
}
